import { Table } from 'antd';
import moment from 'moment';
import React from 'react'

const Federal = ({ data }) => {

    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            width: 60,
            render: (_, record) => <span>{record?.InspCode}</span>
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: 'desc',
            width: 450,
            render: (_, record) => <span>{record?.InspName}</span>
        },
        {
            title: 'Last Date',
            dataIndex: 'age',
            key: 'age',
            render: (_, record) => <span>{record?.LastCompleted ? moment.utc(record?.LastCompleted).format('MM-DD-YYYY') : "N/A"}</span>
        },
        {
            title: 'Next Date',
            dataIndex: 'age',
            key: 'age',
            render: (_, record) => <span>{record?.NextDueDate ? moment.utc(record?.NextDueDate).format('MM-DD-YYYY') : "N/A"}</span>
        },
    ];

    return (
        <Table
            dataSource={data}
            columns={columns}
            pagination={data?.length > 10 ? true : false}
        // scroll={{ x: 'max-content' }}
        />
    )
}

export default Federal